import { gsap } from 'gsap';
import { Container, Sprite } from '../../../odie';
import { CocoonBlockProps } from '../../defs/block';
import { blockPositionView } from '../../util/blockTools';
import { getMatch2AssetPath } from '../../util/assets';
import { MovieClip } from '@play-co/timestep-core/ui';

const manifest = () => ({
  movieclip: {
    url: getMatch2AssetPath('blocks/butterfly'),
    loadMethod: MovieClip.animationLoader,
  },
  fx: 'fx.cocoon/',
});

export class CocoonBlockView extends Container {
  private fx: Sprite;
  private timeline!: gsap.core.Timeline;
  private movieclip: MovieClip;

  constructor(props: CocoonBlockProps) {
    super();

    this.movieclip = new MovieClip({
      superview: this.view,
      url: manifest().movieclip.url,
      scale: 0.9,
    });

    this.fx = Sprite.from('fx.cocoon/fx.cocoon.z.png');
    this.fx.anchorX = this.fx.anchorY = 0.5;
    this.fx.alpha = 0;
    this.addChild(this.fx);

    blockPositionView(this, props);
    this.startAnimation();
  }

  private async startAnimation() {
    await this.movieclip.playAsync('worm_tranisition_1_2');
    this.movieclip.play('worm_state02', null, true);
    const duration = 1.5;
    this.timeline = gsap
      .timeline({ repeat: -1 })
      .set(this.fx, { alpha: 1, scaleX: 0, scaleY: 0, x: 0, y: 3 })
      .to(
        this.fx,
        {
          duration,
          x: 30,
          y: -20,
          ease: 'quad.in',
        },
        duration * 0.5,
      )
      .to(
        this.fx,
        {
          duration,
          scaleX: 0.7,
          scaleY: 0.7,
          ease: 'quad.inOut',
        },
        duration * 0.5,
      )
      .to(
        this.fx,
        {
          duration,
          alpha: 0,
          ease: 'quad.in',
        },
        duration * 0.5,
      );
  }

  public stopAnimation(): void {
    this.timeline.kill();
    this.movieclip.stop();
  }

  public static assets() {
    return Object.values(manifest());
  }
}
